import { render, staticRenderFns } from "./ByUserID.vue?vue&type=template&id=053479e8&"
import script from "./ByUserID.vue?vue&type=script&lang=ts&"
export * from "./ByUserID.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports